import React, { useState } from 'react';
import { Dropdown } from 'antd';
import s from './s.module.less';
import { ColorOptions } from 'constants/common';

interface ColorSelectProps {
    value?: string;
    onChange?: (color: string) => void;
}

const ColorSelector: React.FC<ColorSelectProps> = ({ value = '#DCEEFC', onChange }) => {
    const [open, setOpen] = useState(false);

    const handleColorSelect = (color: string) => {
        onChange?.(color);
        setOpen(false);
    };

    const colorPickerContent = () => (
        <div className={s.colorPickerDropdown}>
            <div className={s.colorGrid}>
                {ColorOptions.map((color) => (
                    <div
                        key={color}
                        className={s.colorOption}
                        style={{ backgroundColor: color }}
                        onClick={() => handleColorSelect(color)}
                    />
                ))}
            </div>
        </div>
    );

    return (
        <Dropdown
            dropdownRender={colorPickerContent}
            trigger={['click']}
            open={open}
            onOpenChange={setOpen}
        >
            <div className={s.colorSelector} onClick={() => setOpen(!open)}>
                <div className={s.colorBox} style={{ backgroundColor: value }} />
                <div className={s.dropdownArrow}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 7.87883C5.68342 7.48831 6.31658 7.48831 6.7071 7.87883L9.99999 11.1717L13.2929 7.87883C13.6834 7.48831 14.3166 7.48831 14.7071 7.87883C15.0976 8.26935 15.0976 8.90252 14.7071 9.29304L10.7071 13.293C10.3166 13.6836 9.68341 13.6836 9.29289 13.293L5.29289 9.29304C4.90237 8.90252 4.90237 8.26935 5.29289 7.87883Z" fill="#111827" />
                    </svg>
                </div>
            </div>
        </Dropdown>
    );
};

export default ColorSelector;
